import axios from "axios";
import { isEmpty, getRates, setRates, clearRates } from "./sessionStorage";

const baseURL = "http://data.fixer.io/api/latest?access_key=";

const fullURL = `${baseURL}${process.env.FIXER_API_KEY}`;

const getAllCurrencies = async () => {
  if (isEmpty()) {
    try {
      const { data } = await axios.get(fullURL);
      console.log(data);
      if (data.success === true) {
        setRates(data.rates);
        return data.rates;
      } return [];
    } catch (err) {
      console.log("an error", err);
      return [];
    }
  } return getRates();
};

const convertFrom = async (currentCurrency, newCurrency) => {
  try {
    const rates = await getAllCurrencies();

    if (rates[currentCurrency] !== undefined) {
      const currentRate = rates[currentCurrency];
      const nextRate = rates[newCurrency];

      const balanceMultiplier = parseFloat((nextRate / currentRate));
      return balanceMultiplier;
    }
    console.log("undefined error");
    return [];
  } catch (error) {
    console.log(error);
    return null;
  }
};

export default convertFrom;